<script setup>
import TripFinderSearchActionButton from './TripFinderSearchActionButton.vue'

defineProps({
  isSearchEnabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['search'])
</script>

<template>
  <div class="tripfinder-mobile-search-footer px-4 pb-8 pt-2 bg-white z-[60] w-full mt-auto">
    <TripFinderSearchActionButton
      :disabled="!isSearchEnabled"
      variant="mobile"
      @search="emit('search')"
    />
  </div>
</template>
